import { put, takeLatest, call, all } from 'redux-saga/effects';
import axios from 'axios';
import { API_URL } from "../../../config";
import { SESSION_EXPIRED } from "../../../_utils/constants/Auth";
import {
  MANUFACTURER_REQUEST,
  MANUFACTURER_SUCCESS,
  MANUFACTURER_FAILED,
  MANUFACTURER_CREATE,
  MANUFACTURER_CREATE_SUCCESS,
  MANUFACTURER_CREATE_FAILED,
  MANUFACTURER_DELETE,
  MANUFACTURER_DELETE_SUCCESS,
  MANUFACTURER_DELETE_FAILED,
  MANUFACTURER_EDIT,
  MANUFACTURER_EDIT_SUCCESS,
  MANUFACTURER_EDIT_FAILED,
} from "../../../_utils/constants/ProductCatalog";


/*****
 * Manufacturer Actions
 */

function* fetchManufacturer({ token }) {
  try {
    const response = yield call(axios.get, `${API_URL}/Product/api/Manufacturer/GetAllManufacturer`, { headers: { Authorization: `Bearer ${token}` } });
    yield put({ type: MANUFACTURER_SUCCESS, payload: response.data });
  } catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({ type: MANUFACTURER_FAILED, payload: error.response });
    }
  }
}

function* createManufacturer(action) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/Product/api/Manufacturer/CreateManufacturer`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: MANUFACTURER_CREATE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: MANUFACTURER_CREATE_FAILED,
        payload: error.response
      });
    }
  }
}
function* editManufacturer(action) {
  try {
    const response = yield call(
      axios.post,
      `${API_URL}/Product/api/Manufacturer/UpdateManufacturer`,
      action.payload.data, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      },
    }
    );
    yield put({
      type: MANUFACTURER_EDIT_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: MANUFACTURER_EDIT_FAILED,
        payload: error.response
      });
    }
  }
}
function* deleteManufacturer(action) {
  try {
    const response = yield call(
      axios.delete,
      `${API_URL}/Product/api/Manufacturer/RemoveManufacturer?ManufacturerId=${encodeURIComponent(action.payload.ManufacturerId)}`, {
      headers: {
        Authorization: `Bearer ${action.payload.token}`
      }
    },
    );
    yield put({
      type: MANUFACTURER_DELETE_SUCCESS,
      payload: response.data
    });
  }
  catch (error) {
    if (error && error.response && error.response.status && error.response.status === 401) {
      yield put({ type: SESSION_EXPIRED });
    } else {
      yield put({
        type: MANUFACTURER_DELETE_FAILED,
        payload: error.response
      });
    }
  }
}



export default function* rootManufacturerList() {
  yield all([
    takeLatest(MANUFACTURER_REQUEST, fetchManufacturer),
    takeLatest(MANUFACTURER_CREATE, createManufacturer),
    takeLatest(MANUFACTURER_DELETE, deleteManufacturer),
    takeLatest(MANUFACTURER_EDIT, editManufacturer),
  ]);
}